import type { ReactNode } from "react"

interface ArcGaugeProps {
  /** 0–100. */
  value: number
  /** Fraction of the full circle the track spans (e.g. 0.6 → 216°), gap centred at bottom. */
  ratio: number
  size: number
  strokeWidth: number
  stroke: string
  trackColor?: string
  children?: ReactNode
}

/**
 * Partial-circle progress gauge (SVG), replacing react-circular-progressbar.
 * The arc is centred at the top with the opening at the bottom.
 */
export function ArcGauge({
  value,
  ratio,
  size,
  strokeWidth,
  stroke,
  trackColor = "rgba(223, 203, 245, 0.2)",
  children,
}: ArcGaugeProps) {
  const r = 50 - strokeWidth / 2
  const rotation = -90 - ratio * 180
  const filled = (ratio * Math.min(Math.max(value, 0), 100)) / 100

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg
        viewBox="0 0 100 100"
        width={size}
        height={size}
        style={{ transform: `rotate(${rotation}deg)` }}
      >
        <circle
          cx="50"
          cy="50"
          r={r}
          fill="none"
          stroke={trackColor}
          strokeWidth={strokeWidth}
          pathLength={1}
          strokeDasharray={`${ratio} 1`}
          strokeLinecap="round"
        />
        <circle
          cx="50"
          cy="50"
          r={r}
          fill="none"
          stroke={stroke}
          strokeWidth={strokeWidth}
          pathLength={1}
          strokeDasharray={`${filled} 1`}
          strokeLinecap="round"
        />
      </svg>
      {children && (
        <div className="absolute inset-0 flex items-center justify-center">{children}</div>
      )}
    </div>
  )
}
